import React, { useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

import { createSurgeryAction } from "../../Actions/SurgeryAction/SurgeryAction";

const SurgeryModal = ({ closeModal }) => {
  const [valueOptions, setValueOptions] = useState([]);
  const dispatch = useDispatch();
  const createSurgery = useSelector((state) => state.createSurgery);
  const { error } = createSurgery;
  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(createSurgeryAction(valueOptions));
    if(error){
        return
    }else{
        closeModal();
        return;
    }
  };

  const handleAdd = (event) => {
    event.preventDefault();
    setValueOptions([...valueOptions, [""]]);
  };
  const handleRemoveInput = (event, index) => {
    event.preventDefault();
    const removeInput = [...valueOptions];
    removeInput.splice(index, 1);
    setValueOptions(removeInput);
  };
  const handleValueOption = (e, index) => {
    const newValue = [...valueOptions];
    newValue[index] = e.target.value;
    setValueOptions(newValue);
  };
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-container">
          <div className="modal-header ">
            <h3 className="cursor-pointer" onClick={closeModal}>
              X
            </h3>
          </div>
          <form action="" onSubmit={handleSubmit}>
            {valueOptions.length < 10 && (
              <div className="w-full  flex justify-end">
                <button className="btn-info " onClick={handleAdd}>
                  <FaPlus />
                </button>
              </div>
            )}

            <div>
              {valueOptions.map((value, index) => {
                return (
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Surgery Name"
                      className="input p-1 mt-1.5"
                      value={value || ""}
                      onChange={(e) => handleValueOption(e, index)}
                      key={index}
                    />
                
                    <button
                      onClick={(e) => handleRemoveInput(e, index)}
                      className="bg-red-500 hover:bg-red-600  text-red-50  mt-2 px-2 py-1"
                    >
                      <FaTrash />
                    </button>
                    
                  </div>
                );
              })}
              <p className="text-red-400">{error && error}</p>
            </div>
            {valueOptions.length > 0 && (
              <div className="modal-footer gap-1 p-0 mt-2">
                <button type="submit" className="btn-primary">
                  Save
                </button>
                <button className="btn-danger" onClick={closeModal}>
                  Close
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default SurgeryModal;
